import React from "react";
import pagenotfound from "../assets/img/pagenotfound.svg";
import { Link } from "react-router-dom";
import { CgArrowRight } from "react-icons/cg";

const PageNotFound = () => {
  return (
    <>
      <div className="container">
        <div className="row mt-3">
          <div className="col-md-6">
            <div className="content-div">
              <h1 className="oops-txt">Ooops...</h1>
              <h1 className="page-not-found-txt">Page not found</h1>
              <p className="page-not-found-para">
                Oops! This page is nowhere to be found. How about going back
                home?
              </p>
              <div className="go-back-btn-div">
                <Link className="go-back-btn" to="/">
                  Go Back <CgArrowRight />
                </Link>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <img
              src={pagenotfound}
              className="page-not-found-img img-fluid"
              alt="Page Not Found"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default PageNotFound;
